/**
 * Build-target and auth infrastructure constants for the app spine. They mirror values that live in
 * `shared/src/commonMain/.../auth/AuthConstants.kt` (used by the backend) — keep both sides in sync.
 */

/** API base path; the fetch transport prepends this to every call (see `createFetchTransport`). */
export const OPS_API_BASE_PATH = "/api"

/** localStorage key + cookie name the auth token is stored under (must match the backend). */
export const AUTH_TOKEN_COOKIE = "_bx-ops-auth-token"

/** Query param the IdP appends with the issued token when bouncing back to the login page. */
export const AUTH_TOKEN_QUERY_PARAM = "_bx-ops-auth-token"

/** Hostnames per target system. localhost dev servers can't do OIDC, so login bounces to these. */
const HOSTS = {
  LIVE: "ops.batix.gmbh",
  DEV: "ops-dev.batix.gmbh",
} as const

/** Which backend system this build targets (baked in at build time via `OPS_SYSTEM`). */
export const OPS_SYSTEM: "LIVE" | "DEV" = process.env.OPS_SYSTEM === "DEV" ? "DEV" : "LIVE"

/** The host the OIDC login redirect targets for this build. */
export const OPS_SYSTEM_HOST: string = HOSTS[OPS_SYSTEM]

/**
 * Public MCP endpoint for this target system — the URL a user pastes into an MCP client (e.g. as a
 * Claude custom connector). Mirrors the backend `OpsMcpPaths.MCP` (`/ops-mcp/mcp`). Derived from the
 * baked-in target host so it's the real public endpoint even when the SPA is served from localhost.
 */
export const OPS_MCP_URL = `https://${OPS_SYSTEM_HOST}/ops-mcp/mcp`

/** True when this build runs against in-app mock data (no real API / auth). */
export const IS_MOCK = process.env.OPS_MOCK === "true"
